import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};
  padding: 1.5rem;
  border-bottom: 0.5rem solid ${({ theme }) => theme.colors.grayLight};
`;

export const SubTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-size: 1rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
